import apiRequest from '@utils/apiRequest';
import {
  SCHEDULE_LIST_URL,
  UPDATE_SCHEDULES,
} from '../../config/apiEndpoints';

export const state = {
  scheduleList: {
    data: [],
    loading: true,
    loadingError: false,
    total: 0,
  },
};

export const getters = {
  scheduleList: state => state.scheduleList.data,
  loading: state => state.loading,
  loadingError: state => state.loadingError,
};

export const mutations = {
  FETCH_SCHEDULE_LIST(state) {
    state.scheduleList = {
      ...state.scheduleList,
      loading: true,
      loadingError: false,
      total: 0,
    };
  },
  FETCH_SCHEDULE_LIST_SUCCESS(state, payload) {
    state.scheduleList = {
      ...state.scheduleList,
      loading: false,
      data: payload.data.data,
      total: payload.data.count,
    };
  },
  FETCH_SCHEDULE_LIST_FAIL(state) {
    state.scheduleList = {
      ...state.scheduleList,
      loading: false,
      loadingError: true,
      total: 0,
    };
  },
};

export const actions = {
  async fetchScheduleList({ commit }, payload = {}) {
    commit('FETCH_SCHEDULE_LIST');
    try {
      const result = await apiRequest({
        url: SCHEDULE_LIST_URL,
      });
      commit('FETCH_SCHEDULE_LIST_SUCCESS', result);
    } catch (error) {
      commit('FETCH_SCHEDULE_LIST_FAIL');
      throw error;
    }
  },
  async updateSchedule({ commit }, payload) {
    try {
      const response = await apiRequest({
        url: UPDATE_SCHEDULES,
        method: 'PUT',
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

};
